// extracted by mini-css-extract-plugin
export default {"cls1":"PageHeader-Container_cls1__zLfKa","cls2":"PageHeader-Container_cls2__vSLnd PageHeader-Container_cls1__zLfKa","disableMargin":"PageHeader-Container_disableMargin__3+FH2"};